import * as Icons from "../icons";
import { SettingsIcon } from "../../header/user-info/icons";

export const NAV_DATA = [
  {
    //label: "Основное меню", //.toUpperCase(),
    items: [
      {
        title: "Главная",
        url: "/",
        icon: Icons.HomeIcon,
        items: [],
      },
      {
        title: "Лента",
        url: "/pages/subscriptions",
        icon: Icons.BellIcon,
        items: [],
      },
      {
        title: "Поиск по объявлениям",
        url: "/pages/tenders",
        icon: Icons.SearchFileIcon,
        items: [],
      },
      {
        title: "Договора",
        url: "/pages/e-contracts",
        icon: Icons.DocumentTextIcon,
        items: [],
      },
      {
        title: "Организации",
        url: "/pages/subjects",
        icon: Icons.BuildingIcon,
        items: [],
      },
      {
        title: "Аналитика",
        url: "/pages/analytics",
        icon: Icons.PieChart,
        items: [],
      },
      {
        title: "Национальный каталог товаров",
        url: "/pages/national-catalog",
        icon: Icons.Table,
        items: [],
      },
      {
        title: "Мой каталог",
        url: "/pages/catalog",
        icon: Icons.CatalogIcon,
        items: [],
      },
      {
        title: "Наши компании",
        url: "/pages/companies",
        icon: Icons.OfficeBuildingIcon,
        items: [],
      },
      {
        title: "Пользователи",
        url: "/pages/users",
        icon: Icons.User,
        items: [],
      },
      {
        title: "Синхронизация",
        url: "/pages/admin/reindex",
        icon: Icons.FourCircle,
        items: [],
      },
      {
        title: "AI",
        url: "/pages/settings",
        icon: SettingsIcon,
        items: [],
      },
    ],
  },
  {
    label: "OTHERS",
    items: [
      {
        title: "Calendar",
        url: "/calendar",
        icon: Icons.Calendar,
        items: [],
      },
      {
        title: "Tables",
        url: "/tables",
        icon: Icons.Table,
        items: [
          {
            title: "Tables",
            url: "/tables",
          },
        ],
      },
      {
        title: "Forms",
        icon: Icons.Alphabet,
        items: [
          {
            title: "Form Elements",
            url: "/forms/form-elements",
          },
          {
            title: "Form Layout",
            url: "/forms/form-layout",
          },
        ],
      },
      {
        title: "Charts",
        icon: Icons.PieChart,
        items: [
          {
            title: "Basic Chart",
            url: "/charts/basic-chart",
          },
        ],
      },
      {
        title: "UI Elements",
        icon: Icons.FourCircle,
        items: [
          {
            title: "Alerts",
            url: "/ui-elements/alerts",
          },
          {
            title: "Buttons",
            url: "/ui-elements/buttons",
          },
        ],
      },
      {
        title: "Authentication",
        icon: Icons.Authentication,
        items: [
          {
            title: "Sign In",
            url: "/auth/sign-in",
          },
        ],
      },
    ],
  },
];
